<template>
  <div v-if="value && Object.keys(value).length > 0" :qaid="`store-locator-card__store-${value.id}`">
    <div v-if="value.isMyStore" class="mt-1 lg:ml-2 flex" qaid="store-locator-card__favorite_indicator">
      <i class="material-icons">favorite</i> <span class="ml-1 font-bold">{{ bp('storeFinderYourStore') }}</span>
    </div>
    <div
      class="locator-store-card cursor-pointer"
      :class="{hovered: pinHovered}"
      qaid="store-locator-card__card"
      @click.prevent="storeClicked"
    >
      <div class="media-object">
        <div class="media-object__section sm:hidden md:block">
          <div>
            <img
              :src="storeImage"
              class="w-24 h-auto lazyload"
              qaid="store-locator-card__image"
              @error="usePlaceholder"
            />
          </div>
        </div>
        <div class="media-object__section text-sm">
          <div class="text-md font-bold" qaid="store-locator-card__name" v-html="value.name"></div>
          <p qaid="store-locator-card__address" v-html="value.address"></p>
          <div class="flex">
            <span qaid="store-locator-card__distance">{{ value.distance }}</span>
            <span class="inline-block mx-25">&bull;</span>
            <span
              class="font-bold mr-25"
              qaid="store-locator-card__open-status"
              v-html="storeStatus(value.statusText)"
            ></span>
            <div qaid="store-locator-card__hours">
              <div v-for="(hour, i) in value.statusHours" :key="`hour-${value.id}${i}`">{{ hour }}</div>
            </div>
          </div>
          <badge-group
            v-if="badges && badges.length > 0"
            class="mt-1"
            :badges="badges"
            qaid="store-locator-card__badges"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get';
import BadgeGroup from '@/components/BadgeGroup';
import {Badges} from '@/components/locator/mixins/badges';
import {Constants} from '@/components/locator/mixins/constants';

export default {
  name: 'LocatorCard',
  components: {BadgeGroup},
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    pinHovered: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    badges() {
      let result = [];
      Badges.forEach((badge) => {
        if (get(this.value, `badges.${badge.id}`, false) !== true) {
          return;
        }

        result.push({
          id: badge.id,
          qaid: badge.id,
          class: `${badge.id == 'bestSelection' ? 'b2b-badge--success-light' : ''} ${
            badge.id == 'sale' ? 'b2b-badge--primary-light' : ''
          }`,
          text: this.bp(badge.name),
        });
      });

      return result;
    },

    storeImage() {
      return this.value.thumbnail ?? this.usePlaceholder();
    },
  },
  methods: {
    usePlaceholder(e) {
      if (e && e.target) {
        e.target.src = Constants.storePlaceholder(292, 219);
      } else {
        return Constants.storePlaceholder(292, 219);
      }
    },

    storeClicked() {
      this.$emit('store-clicked', this.value.id, this.value.distance);
    },

    storeStatus(status) {
      if (!status) return null;

      if (status.toLowerCase() == 'closed') {
        return this.bp(status);
      } else {
        return this.bp(`open${status}`);
      }
    },
  },
};
</script>
